import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormField } from '../lib/form-field.model';
import { FormPermission } from '../lib/form-permission.model';
import { FormEditorService } from './form-editor.service';
import { WorkflowFormFieldItemPermissionEvent } from './form-field-item.component';
import { CdkDragDrop } from '@angular/cdk/drag-drop';

@Component({
    selector: 'eas-workflow-form-field-list',
    templateUrl: './form-field-list.component.html',
    styleUrls: ['./form-field-list.component.css'],
    standalone: false
})
export class WorkflowFormFieldListComponent implements OnInit {

  @Input() items: FormField[] = [];
  @Output() addField = new EventEmitter<undefined>();
  @Output() editField = new EventEmitter<string>();
  @Output() setPermission = new EventEmitter<WorkflowFormFieldItemPermissionEvent>();
  @Output() removePermission = new EventEmitter<WorkflowFormFieldItemPermissionEvent>();
  @Output() moveFieldUp = new EventEmitter<string>();
  @Output() moveFieldDown = new EventEmitter<string>();
  @Output() dropField = new EventEmitter<{id: string, to: number}>();

  constructor(private formEditor: FormEditorService) {}

  ngOnInit(): void { }

  //
  // Actions
  //

  public onAddField(): void { this.addField.emit(); }
  public onEditField(event: string): void { this.editField.emit(event); }
  public onSetPermission(event: WorkflowFormFieldItemPermissionEvent): void { this.setPermission.emit(event); }
  public onRemovePermission(event: WorkflowFormFieldItemPermissionEvent): void { this.removePermission.emit(event); }
  public onMoveFieldUp(event: string): void { this.moveFieldUp.emit(event); }
  public onMoveFieldDown(event: string): void { this.moveFieldDown.emit(event); }

  //
  // Template helpers
  //

  public get isEmpty(): boolean {
    return this.items.length === 0;
  }

  public permissionForItem(item: FormField): FormPermission|undefined {
    const permissions =
      this.formEditor.findPermissionsForField(item.id);
    return permissions.length === 0 || permissions.length > 1
           ? undefined
           : permissions[0];
  }

  public canChangePermissionForItem(_item: FormField): boolean {
    return this.formEditor.stateRoleSettings !== undefined;
  }

  public drop(event: CdkDragDrop<string[]>, id: string) {
    this.dropField.emit({ id, to: event.currentIndex });
  }
}
